import React from 'react';
import { styled } from 'styled-components';

import { Flex } from '@rover/kibble/core';
import MQ from '@rover/kibble/styles/MediaQuery';
import CrossVerticalServiceSelect from '@rover/react-lib/src/pages/shared/cross-vertical-search/CrossVerticalServiceSelect/CrossVerticalServiceSelect';
import { ServiceTypeSlug } from '@rover/types/src/ServiceType';

import { SkillsAndBehaviorSlugsDictionary } from '../../utils/params';
import { FilterSectionLayout } from '../layouts';

import { TrainingNeedsForm } from './TrainingNeedsForm/TrainingNeedsForm';
import FilterForm from './FilterForm';
import { FormState } from './filterFormState';
import StaticServiceTypeFilter from './StaticServiceTypeFilter';

const ServiceTypeFilterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.space['4x']};

  ${MQ.XS_DOWN.toString()} {
    display: none;
  }
`;

export type FilterSectionProps = {
  onSubmit: (formData: FormState) => void;
  query: Partial<FormState>;
  selectedSkillsAndBehaviors: SkillsAndBehaviorSlugsDictionary;
  updateSkillsAndBehaviors: (skillsAndBehaviors: SkillsAndBehaviorSlugsDictionary) => void;
};

export default function FilterSection({
  onSubmit,
  query,
  selectedSkillsAndBehaviors,
  updateSkillsAndBehaviors,
}: FilterSectionProps): JSX.Element {
  return (
    <FilterSectionLayout stickyTopMobile="0">
      <Flex flexDirection="column">
        <ServiceTypeFilterWrapper>
          <CrossVerticalServiceSelect
            pageServiceTypeSlug={ServiceTypeSlug.DOG_TRAINING}
            staticSelector={<StaticServiceTypeFilter />}
          />
        </ServiceTypeFilterWrapper>
        <Flex flexDirection="column" gap="4x">
          <FilterForm onSubmit={onSubmit} query={query} />
          <TrainingNeedsForm
            selectedSkillsAndBehaviors={selectedSkillsAndBehaviors}
            updateSkillsAndBehaviors={updateSkillsAndBehaviors}
          />
        </Flex>
      </Flex>
    </FilterSectionLayout>
  );
}
